import {Injectable} from "@angular/core";
import {AlertInstance} from "../interfaces/domain/alert/AlertInstance";

@Injectable({
  providedIn: 'root',
})
export class SessionStorageRepository {

  private readonly KEY_ALERT_INSTANCES = 'alertInstances';

  constructor() {
    // empty
  }

  saveAlertInstances(alertInstances: Array<AlertInstance>): void {
    if(alertInstances && alertInstances.length > 0) {
      sessionStorage.setItem(this.KEY_ALERT_INSTANCES, JSON.stringify(alertInstances));
    }
    else {
      this.removeAlertInstances();
    }
  }

  removeAlertInstances(): void {
    sessionStorage.removeItem(this.KEY_ALERT_INSTANCES);
  }

  getAlertInstances(): Array<AlertInstance> {
    const rawData = sessionStorage.getItem(this.KEY_ALERT_INSTANCES);

    if(rawData) {
      return JSON.parse(rawData);
    }

    return [];
  }
}
